<script setup lang="ts">
  import type { FillLogsChangeItem } from '../model/fill-logs-text';
  import FillLogsChangeItemView from './FillLogsChangeItem.vue';

  defineProps<{ items: FillLogsChangeItem[] }>();
  const emit = defineEmits<{ (e: 'show', item: FillLogsChangeItem): void }>();
</script>

<template>
  <ul
    class="divide-y divide-gray-02"
    data-testid="fill-logs-changes"
  >
    <li
      v-for="item in items"
      :key="item.key"
    >
      <FillLogsChangeItemView
        :item="item"
        @show="emit('show', $event)"
      />
    </li>
  </ul>
</template>
